import React from 'react';
import '../Styles/NavCard.css';

const NavCard = ({name,image,price}) => {
  return (
    <div className='navCard'>
        <img src={image}></img>
        <p>{name}</p>
        <span>{price}</span>
    </div>
  )
}

export default NavCard